module.exports = __webpack_public_path__ + "feecc8c03758df80ff5b35a7e1a2f65b.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/madlaina-kalunder.jpg
// module id = 445
// module chunks = 0